import { ReactComponent as IconFolder } from '@/assets/svgs/folder.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import useFolders from '@/hooks/use-folder/index'
import rem from '@/utils/rem'

export default function DeleteFolderModal({ visible, close, id }) {

	const {deleteFolder, loading} = useFolders();

	const handleDeleteFolderSubmit = async () => {
		await deleteFolder(id)
		document.getElementById('reload-eclips')?.click();
		close()
	}

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconFolder />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<span style={{ color: '#A72E12' }}> Delete Package Folder</span>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div style={{ fontSize: rem(14), textAlign: 'center' }}>
						Are you sure want to delete the selected Package folder ?
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button text="Confirm" submit={handleDeleteFolderSubmit} />
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
